import { flattenOptionsArray } from './flattenedOptions';
import { getOptionsOnlyFixed, getOptionsWithoutFixed } from './getOptions';
import { handleIsSelected } from './handleIsSelected';
import { isArray, isNilOrEmpty, isNotNilOrEmpty } from '@pcty/utils';
export var handleOptionsArrays = function (_a) {
    var isActivated = _a.isActivated, isMulti = _a.isMulti, isLoaded = _a.isLoaded, propsOptions = _a.propsOptions, primaryKey = _a.primaryKey, propsValue = _a.propsValue, persistedInputValue = _a.persistedInputValue, value = _a.value, listDataArray = _a.listDataArray, setOptionsDataArrayWithoutFixed = _a.setOptionsDataArrayWithoutFixed, setFixedOptions = _a.setFixedOptions, setOptions = _a.setOptions, setListDataArray = _a.setListDataArray, setValue = _a.setValue, setFlattenedOptions = _a.setFlattenedOptions, setIsActivated = _a.setIsActivated;
    var flattened = flattenOptionsArray(propsOptions, primaryKey);
    var flatOpt = flattened.flattenedOptions;
    var flatVal = propsValue;
    var noFixedOpt = getOptionsWithoutFixed(flatOpt);
    var onlyFixed = getOptionsOnlyFixed(flatOpt);
    // setting initial flat values here to determine selected options when isMulti
    if (!isActivated) {
        if (isMulti && (isArray(propsValue) || isNilOrEmpty(propsValue))) {
            var _propsValue = propsValue;
            var flattenTemp = _propsValue ? _propsValue.filter(function (x) { return !x.isFixed; }) : [];
            var flattened_1 = flattenOptionsArray(flattenTemp, primaryKey);
            flatVal = flattened_1.flattenedOptions;
            if (!isLoaded) {
                setOptionsDataArrayWithoutFixed(noFixedOpt);
                setFixedOptions(onlyFixed);
                setOptions(flatOpt);
                setListDataArray(noFixedOpt);
            }
        }
        // select the flattened values
        if (isNotNilOrEmpty(propsValue)) {
            handleIsSelected(flatOpt, flatVal, flattened.optionIndexMap, propsValue, primaryKey, isMulti, value, persistedInputValue, listDataArray, setListDataArray, setValue, setFlattenedOptions);
        }
        return setIsActivated(true);
    }
    setOptionsDataArrayWithoutFixed(noFixedOpt);
    setFixedOptions(onlyFixed);
    setOptions(flatOpt);
    if (!persistedInputValue) {
        setListDataArray(isMulti ? noFixedOpt : flatOpt);
    }
    handleIsSelected(flatOpt, flatVal, flattened.optionIndexMap, propsValue, primaryKey, isMulti, value, persistedInputValue, listDataArray, setListDataArray, setValue, setFlattenedOptions);
};
